<template>
  <div class="coupCintainer">
    <md-field>
      <md-input-item
        ref="input0"
        v-model="code"
        placeholder="請輸入兌換碼">
        <div class="viewbtn" slot="right" @click="getMessageCount">
          <span>兌換</span>
        </div>
      </md-input-item>
    </md-field>
    <md-tabs>
      <div style="width: 100%;height: 0.6rem"></div>
      <md-tab-pane class="content" name="p1" :label="titleone">
        <div v-if="listone.length>0" style="width: 96%;margin-left: 2%">
          <div class="coupitem" v-for="(item,index) in listone" :key="index">
            <div class="couypleft">
              <span class="price" v-if="item.type!=2">￥{{item.price}}</span>
              <span class="price" v-if="item.type==2">{{item.price}}折</span>
              <span class="rule" v-if="item.thresholdPrice>0">滿{{item.thresholdPrice}}可用</span>
              <span class="rule" v-if="item.thresholdPrice==0">無門檻使用</span>
            </div>
            <div class="couypright">
              <span class="name">{{item.name}}</span>
              <span class="rule">有效期：{{item.beginTime| dateformat('YYYY-MM-DD')}}-{{item.endTime| dateformat('YYYY-MM-DD')}}</span>
              <div class="krkkrt"><span>{{item.countryName}}</span></div>
            </div>
          </div>
        </div>
        <noth-modal v-else></noth-modal>
      </md-tab-pane>
      <md-tab-pane class="content" name="p2" :label="titletwo">
        <div v-if="listtwo.length>0" style="width: 90%;margin-left: 5%">
          <div class="coupitem" v-for="(item,index) in listtwo" :key="index" style="padding-bottom: 0.4rem;background-color: #e2e4ea">
            <div class="couypleft" >
              <span class="price" v-if="item.type!=2" style="color: #cccccc">￥{{item.price}}</span>
              <span class="price" v-if="item.type==2" style="color: #cccccc">{{item.price}}折</span>
              <span class="rule" v-if="item.thresholdPrice>0">滿{{item.thresholdPrice}}可用</span>
              <span class="rule" v-if="item.thresholdPrice==0">無門檻使用</span>
            </div>
            <div class="couypright" >
              <span class="name">{{item.name}}</span>
              <span class="rule">有效期：{{item.beginTime| dateformat('YYYY-MM-DD')}}-{{item.endTime| dateformat('YYYY-MM-DD')}}</span>
              <div class="krkkrt" style="background-color: #999999"><span>{{item.countryName}}</span></div>
            </div>
            <div class="banner" style="color: #cccccc">
                            <span v-if="item.status==1">已過期</span>
                            <span v-if="item.status==2">暫不使用</span>
            </div>
          </div>
        </div>
        <noth-modal v-else></noth-modal>
      </md-tab-pane>
    </md-tabs>
  </div>
</template>

<script>
import { InputItem, Field, Tabs, TabPane, Toast } from 'mand-mobile'
import NothModal from '../Modal/NothModal'

export default {
  name: 'coup',
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data () {
    return {
      code: '',
      titleone: '可使用優惠券(0)',
      titletwo: '已失效優惠券(0)',
      listone: [],
      listtwo: []
    }
  },
  activated () {
    this.getlist()
  },
  methods: {
    getlist () {
      this.couponslist()
      this.couponslisttwo()
    },
    getMessageCount () {
      if (!this.code) {
        return
      }
      const par = {
        code: this.code
      }
      this.http.APIASK(this.ports.couponsexchange, 'post', par).then(res => {
        Toast.succeed('兌換成功')
        this.getlist()
      }).catch(err => {
      })
    },
    couponslist () {
      const par = {
        status: 4
      }
      this.http.APIASK(this.ports.couponslist, 'get', par).then(res => {
        this.listtwo = res
        this.titletwo = '已失效優惠券' + '(' + this.listtwo.length + ')'
      }).catch(err => {
      })
    },
    couponslisttwo () {
      const par = {
        status: 1
      }
      this.http.APIASK(this.ports.couponslist, 'get', par).then(res => {
        this.listone = res
        this.titleone = '可使用優惠券' + '(' + this.listone.length + ')'
      }).catch(err => {
      })
    }
  }
}
</script>

<style lang="less">
.md-tab-bar-item.is-active{
  color: #e32c1a;
}
.md-tab-bar-ink{
  background-color: #e32c1a;
}

  .coupCintainer {
    .md-field {
      padding: 0 0.4rem;
    }
    .md-tab-bar {
      position: static;
      height: 1rem;
    }
    .viewbtn {
      padding: 0.2rem 0.4rem;
      background-color: rgba(236, 112, 74, 1);
      color: rgba(255, 255, 255, 1);
      border-radius: 0.1rem;
      font-size: 0.32rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .coupitem {
      margin-top: 0.2rem;
      display: flex;
      border-radius: 0.1rem;
      align-items: center;
      background-color: white;
      position: relative;
      .banner{
        position: absolute;
        font-size: 0.2rem;
        bottom: 0.1rem;
        left: 0.5rem;
      }
      .couypleft {
        padding: 0.2rem 0;
        display: flex;
        padding-left: 0.5rem;
        flex-direction: column;
        font-size: 0.22rem;
        align-items: flex-start;
         margin-top: -0.5rem;
        .price {
          font-size: 0.45rem;
          color: #F97004;
          margin-bottom: 0.2rem;
        }

        .rule {
          color: #cccccc;
        }


      }
      .couypright{
        padding: 0.15rem 0;
        display: flex;
        padding-left: 0.5rem;
        flex-direction: column;
        font-size: 0.28rem;
        align-items: flex-start;
        margin-top: 0.2rem;
        .name {
          font-size: 0.32rem;
          margin-bottom: 0.2rem;
          font-weight: bolder;
        }
        .rule {
          color: #cccccc;
        }
        .krkkrt{
          padding: 0.08rem 0.1rem;
          background-color: #2a78dc;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 0.2rem;
          margin-top: 0.2rem;
          border-radius: 0.08rem;
        }
      }
    }
  }
</style>
